import { Breadcrumb } from 'antd';
import styles from './categoryBreadcrumb.module.scss';
import { CategoryType } from 'types';
import { catIconData } from 'data/categoryIcon';

export default function CategoryBreadcrumb(props: {
    list: CategoryType<'list'>[];
    onClick?: (cat: CategoryType<'list'>) => void;
}) {
    if (props.list.length === 0) return null;

    return (
        <div
            className={`${styles['breadcrumb-category-card']} center-content-y justify-content-between pointer`}
            onClick={() => props.onClick?.(props.list[props.list.length - 1])}
        >
            <Breadcrumb
                separator={<p className="t-l-black1 t-d-gray2">{'>'}</p>}
                items={props.list.map((cat, index) => {
                    const Icon = catIconData.find((i) => i.key === cat.icon);
                    return {
                        title: (
                            <div className="g-2">
                                {Icon ? <Icon.icon size={20} className="t-primary" /> : null}{' '}
                                <p className={`t-l-black1 t-d-gray2 ${index + 1 === props.list.length ? 't-600' : ''}`}>
                                    {cat.title}
                                </p>
                            </div>
                        ),
                    };
                })}
            />
        </div>
    );
}
